import { render, staticRenderFns } from "./OnetimeLogin.vue?vue&type=template&id=0ef61c44"
import script from "./OnetimeLogin.vue?vue&type=script&lang=js"
export * from "./OnetimeLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports